/**
 * Support file for polyfilling before import of vendor bundles.
 * Especially needed for compatibility with IE11.
 * Without this, React and ReactDOM will not work (some ES6 features used in there).
 */
'use strict';

// Import order matters, should be:
//    import 'core-js/stable';
//    import 'regenerator-runtime/runtime';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
